import { render, staticRenderFns } from "./vsCol.vue?vue&type=template&id=68e4485c&lang=html&"
import script from "./vsCol.vue?vue&type=script&lang=js&"
export * from "./vsCol.vue?vue&type=script&lang=js&"
import style0 from "./vsCol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsCol.vue"
export default component.exports